import React, { useContext } from 'react';
import { Badge, makeStyles } from '@fluentui/react-components';
import { Resize20Filled } from '@fluentui/react-icons';

import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';
import { curlyTemplate } from '@bingads-webui-universal/primitive-utilities';

const useVariantCountStyles = makeStyles({
  icon: {
    height: '16px',
    width: '16px',
  },
});

export const VariantCount: React.FC<{ count: number }> = React.memo(({ count }) => {
  const i18n = useContext(I18nContext) as I18nModel;
  const classes = useVariantCountStyles();

  const label = curlyTemplate(i18n.getString(_TL_('{{count}} sizes')))({ count });

  return (
    <Badge
      className="variant-count-badge"
      shape="rounded"
      color="important"
      size="large"
      icon={<Resize20Filled className={classes.icon} />}
      aria-label={label}
      title={label}
    >
      {count}
    </Badge>
  );
});
